import { RGBtoHex, parseColor } from 'vuetify/lib/util/colorUtils.mjs'
import type { Color } from 'vuetify/lib/util/colorUtils.mjs'
import colors from 'vuetify/util/colors'

import { camelCase } from 'es-toolkit'

/** Resolves Vuetify palette names and theme tokens to canvas-compatible colors. */
export function resolveFaviconColor(color: string | undefined, themeColors: Record<string, Color>): string {
  if (!color) return colors.grey.base

  if (Object.hasOwn(themeColors, color)) {
    const themeColor = themeColors[color]!

    return typeof themeColor === 'string' ? themeColor : RGBtoHex(parseColor(themeColor))
  }

  const palette = colors as Record<string, Record<string, string>>
  const [name, variant] = color.split(/-(?=lighten|darken|accent)/)
  const shades = Object.hasOwn(palette, camelCase(name!)) ? palette[camelCase(name!)] : undefined
  const shade = variant ? camelCase(variant) : 'base'

  return shades && Object.hasOwn(shades, shade) ? shades[shade]! : color
}
